// extracted by mini-css-extract-plugin
export default {"iconFlexSvg":"style_iconFlexSvg__gFczY"};